export const ADVERTISING_CATALOG_URL = '/advertising/catalog';
